module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "left",
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "calc(100% - 72px)"
    },
    attrs: {
      "id": "pageContainer"
    }
  }, [_c('b-navbar', {
    staticClass: "navbar-toggleable-sm",
    attrs: {
      "type": "inverse",
      "variant": "success",
      "id": "mainMenu"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-brand"
  }, [_vm._v("Mexmat-disk")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "toolbar-container"
    }
  }, [_c('div', {
    staticClass: "toolbar",
    attrs: {
      "id": "toolbar"
    }
  }, [_c('b-popover', {
    attrs: {
      "triggers": ['hover'],
      "placement": "bottom",
      "content": "Удалить выделенные"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.deleteFiles
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/delete.png")
    }
  })])], 1), _vm._v(" "), _c('b-popover', {
    attrs: {
      "triggers": ['hover'],
      "placement": "bottom",
      "content": "Скачать выделенные"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.download(null)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/download.png")
    }
  })])], 1), _vm._v(" "), _c('b-popover', {
    attrs: {
      "triggers": ['hover'],
      "placement": "bottom",
      "content": "Загрузить на сервер"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.chooseFileToUpload
    }
  }, [_c('div', {
    attrs: {
      "id": "uploadButtonSpan"
    }
  }, [(_vm.isFileUploading) ? _c('span', {
    attrs: {
      "id": "uploadProgress"
    }
  }) : _vm._e()])])], 1), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "inline-block",
      "width": "0px",
      "height": "0px",
      "overflow": "hidden"
    },
    attrs: {
      "id": "uploadFileForm"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "uploadFile",
      "name": "uploadFile",
      "multiple": ""
    },
    on: {
      "change": _vm.startUpload
    }
  })]), _vm._v(" "), _c('b-popover', {
    attrs: {
      "triggers": ['hover'],
      "placement": "bottom",
      "content": "Создать папку"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-prevent-closing",
      modifiers: {
        "modal-prevent-closing": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.folderNameDialog.show()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/createFolder.png")
    }
  })])], 1)], 1)]), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.authType !== 'teacher') ? _c('b-nav-item', {
    on: {
      "click": function($event) {
        _vm.$refs.changePassRef.show()
      }
    }
  }, [_vm._v("Сменить пароль")]) : _vm._e(), _vm._v(" "), (_vm.authType == 'teacher') ? _c('b-nav-item', {
    on: {
      "click": function($event) {
        _vm.$refs.erasePassRef.show()
      }
    }
  }, [_vm._v("Сбросить пароль школьнику")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    on: {
      "click": function($event) {
        _vm.$refs.contactSupportRef.show()
      }
    }
  }, [_vm._v("Поддержка")]), _vm._v(" "), _c('b-nav-item', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Выйти")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-page-content"
  }, [_c('div', {
    staticClass: "alertsBlock"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.showAlert,
      "variant": "danger"
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = 1
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.alertText) + "  ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.showMessage,
      "variant": "success"
    },
    on: {
      "dismissed": function($event) {
        _vm.showMessage = 1
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.messageText) + "  ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "confirmDialogRef",
    attrs: {
      "id": "confirmDialog",
      "title": _vm.confirm.title,
      "okTitle": _vm.confirm.okTitle,
      "closeTitle": _vm.confirm.closeTitle,
      "ok2Title": _vm.confirm.ok2Title
    },
    on: {
      "ok": _vm.confirm.actionOk
    }
  }, [_vm._v("\n    " + _vm._s(_vm.confirm.message) + "\n  ")]), _vm._v(" "), (_vm.showCreateFolderDialog) ? _c('Dialogue', {
    attrs: {
      "dialog-type": _vm.dialogType,
      "template-name": _vm.templateName,
      "web-socket": _vm.webSocket,
      "current-folder": _vm.currentFolder
    },
    on: {
      "close": function($event) {
        _vm.showCreateFolderDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "folderNameDialog",
    attrs: {
      "id": "folderNameDialog",
      "title": "Создание папки",
      "okTitle": "Создать",
      "closeTitle": "Отмена"
    },
    on: {
      "ok": _vm.createFolder
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createFolder($event)
      }
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Введите имя папки"
    },
    model: {
      value: (_vm.newFolderName),
      callback: function($$v) {
        _vm.newFolderName = $$v
      },
      expression: "newFolderName"
    }
  })], 1)]), _vm._v(" "), (_vm.showSupportDialog) ? _c('Dialogue', {
    attrs: {
      "dialog-type": _vm.dialogType,
      "template-name": _vm.templateName,
      "web-socket": _vm.webSocket,
      "current-folder": _vm.currentFolder
    },
    on: {
      "close": function($event) {
        _vm.showSupportDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "contactSupportRef",
    attrs: {
      "id": "contactSupport",
      "title": "Написать в службу поддержки",
      "okTitle": "Отправить",
      "closeTitle": "Отмена"
    },
    on: {
      "ok": _vm.contactSupport
    }
  }, [_c('form', [_c('b-form-input', {
    attrs: {
      "placeholder": "Напишите свой вопрос. Укажите ваш почтовый адрес для ответа",
      "textarea": true,
      "rows": 20
    },
    model: {
      value: (_vm.contactSupportMessage),
      callback: function($$v) {
        _vm.contactSupportMessage = $$v
      },
      expression: "contactSupportMessage"
    }
  })], 1)]), _vm._v(" "), (_vm.showPassDialog) ? _c('Dialogue', {
    attrs: {
      "dialog-type": _vm.dialogType,
      "template-name": _vm.templateName,
      "web-socket": _vm.webSocket,
      "current-folder": _vm.currentFolder
    },
    on: {
      "close": function($event) {
        _vm.showPassDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "changePassRef",
    attrs: {
      "id": "changePass",
      "title": "Смена пароля",
      "okTitle": "Сменить",
      "closeTitle": "Отмена",
      "hideFooter": true
    }
  }, [_c('form', [_c('b-form-input', {
    staticStyle: {
      "margin-bottom": "1rem"
    },
    attrs: {
      "type": "password",
      "placeholder": "Введите новый пароль"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.changePass($event)
      }
    },
    model: {
      value: (_vm.password1),
      callback: function($$v) {
        _vm.password1 = $$v
      },
      expression: "password1"
    }
  }), _c('br'), _vm._v(" "), _c('b-form-input', {
    staticStyle: {
      "margin-bottom": "1rem"
    },
    attrs: {
      "type": "password",
      "placeholder": "Подтвердите пароль",
      "lazy-formatter": ""
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.changePass($event)
      }
    },
    model: {
      value: (_vm.password2),
      callback: function($$v) {
        _vm.password2 = $$v
      },
      expression: "password2"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [_c('b-alert', {
    attrs: {
      "show": _vm.password1 != _vm.password2 && _vm.password2 != '',
      "variant": "danger"
    }
  }, [_vm._v("  Пароли не совпадают  ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.changePassRef.hide(true)
      }
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.changePass
    }
  }, [_vm._v("Сменить")])])], 2)]), _vm._v(" "), (_vm.showErasePassDialog) ? _c('Dialogue', {
    attrs: {
      "dialog-type": _vm.dialogType,
      "template-name": _vm.templateName,
      "web-socket": _vm.webSocket,
      "current-folder": _vm.currentFolder
    },
    on: {
      "close": function($event) {
        _vm.showErasePassDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "erasePassRef",
    attrs: {
      "id": "erasePass",
      "title": "Сбросить пароль",
      "okTitle": "Сбросить",
      "closeTitle": "Отмена",
      "hideFooter": true
    }
  }, [_c('form', [_c('table', {
    staticStyle: {
      "height": "calc(100%)"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "align-middle"
  }, [_c('div', {
    staticClass: "main-login main-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.optionsSchoolGroup
    },
    nativeOn: {
      "change": function($event) {
        _vm.loadFIOList()
      }
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.FIOList,
      "disabled": _vm.selectedGroup == null || _vm.FIOList.length == 1
    },
    model: {
      value: (_vm.selectedStudentFIOList),
      callback: function($$v) {
        _vm.selectedStudentFIOList = $$v
      },
      expression: "selectedStudentFIOList"
    }
  })], 1), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.showAlert,
      "state": "danger"
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = 1
      }
    }
  }, [_vm._v("  " + _vm._s(_vm.alertText) + " ")])], 1)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [_c('b-btn', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.erasePassRef.hide(true)
      }
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.selectedStudentFIOList == null || _vm.selectedGroup == null
    },
    on: {
      "click": _vm.erasePass
    }
  }, [_vm._v("Сбросить")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs"
  }, [_c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbs
    },
    on: {
      "click": _vm.changeDirBreadcrumb
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "files"
  }, [_c('div', [_c('div', {
    staticClass: "header file"
  }, [_c('b-form-checkbox', {
    on: {
      "change": function($event) {
        _vm.selectAll($event)
      }
    },
    model: {
      value: (_vm.selectAllValue),
      callback: function($$v) {
        _vm.selectAllValue = $$v
      },
      expression: "selectAllValue"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "44px",
      "height": "45px",
      "overflow": "hidden"
    }
  }, [(_vm.currentFolder !== _vm.homeFolder) ? _c('b-button', {
    staticClass: "btn exitFolderButton",
    on: {
      "click": function($event) {
        _vm.exitFolder()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/directory-icon1.png")
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "file-col-name",
    on: {
      "click": function($event) {
        _vm.sort(_vm.files, 'names')
      }
    }
  }, [_vm._v("Имя файла "), _c('b-button', {
    class: 'btn' + (_vm.whatSort == 0 ? ' active' : '')
  }, [(_vm.sortType[0] != 1) ? _c('span', [_vm._v(" ▴ ")]) : _c('span', [_vm._v(" ▾ ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "file-col-size",
    on: {
      "click": function($event) {
        _vm.sort(_vm.files, 'sizes')
      }
    }
  }, [_vm._v("Размер  "), _c('b-button', {
    class: 'btn' + (_vm.whatSort == 1 ? ' active' : '')
  }, [(_vm.sortType[1] != 1) ? _c('span', [_vm._v(" ▴ ")]) : _c('span', [_vm._v(" ▾ ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "file-col-date",
    on: {
      "click": function($event) {
        _vm.sort(_vm.files, 'dates')
      }
    }
  }, [_vm._v("Дата  "), _c('b-button', {
    class: 'btn' + (_vm.whatSort == 2 ? ' active' : '')
  }, [(_vm.sortType[2] != 1) ? _c('span', [_vm._v(" ▴ ")]) : _c('span', [_vm._v(" ▾ ")])])], 1)], 1)]), _vm._v(" "), _vm._l((_vm.files), function(file) {
    return _c('div', {
      key: file.id
    }, [_c('div', {
      staticClass: "file",
      class: (file.isDir ? 'directory' : '') + (file.checked ? ' checked' : '')
    }, [_c('b-form-checkbox', {
      model: {
        value: (file.checked),
        callback: function($$v) {
          file.checked = $$v
        },
        expression: "file.checked"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "file-col-name",
      on: {
        "dblclick": function($event) {
          _vm.open(file, true)
        },
        "click": function($event) {
          file.checked = !file.checked
        }
      }
    }, [_vm._v(" " + _vm._s(file.name))]), _vm._v(" "), _c('div', {
      staticClass: "file-col-actions"
    }, [_c('span', [_c('b-btn', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.download(file.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../assets/downloadSmall.png")
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "file-col-size"
    }, [(!file.isDir) ? _c('span', [_vm._v(_vm._s(_vm.formatMem(file.size, ' ')))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "file-col-date"
    }, [_vm._v(_vm._s(file.date))])], 1)])
  })], 2)], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('drop', {
    staticStyle: {
      "background": "rgba(0, 0, 0, 0.5)",
      "position": "fixed",
      "top": "0",
      "right": "0",
      "bottom": "0",
      "left": "0",
      "z-index": "1000",
      "visibility": "hidden",
      "opacity": "0",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "id": "dragForm"
    },
    on: {
      "drop": _vm.dropFiles,
      "dragenter": _vm.dragEnter,
      "dragleave": _vm.dragLeave
    }
  }, [_c('div', {
    staticStyle: {
      "color": "white",
      "text-align": "center",
      "font-size": "2em",
      "width": "100%"
    },
    attrs: {
      "id": "percentDrop"
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('img', {
    attrs: {
      "src": require("./../assets/logo.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.mmcs.sfedu.ru/"
    }
  }, [_vm._v("Институт математики механики и компьютерных наук имени И.И.Воровича")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bcc0f5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage.vue
// module id = 224
// module chunks = 0